import { actions, elements } from '@ecosystem/newron-design-system';
import { EditGroupMode } from '@models/CategoryLeaderboard';
import { GroupState } from '@models/Products';
import * as styles from '@utils/tableViewscss/TableViewBoard.module.scss';
import classnames from 'classnames';
import React from 'react';
import { isShareGroupButtonDisable } from '@utils/TableUtils';

interface GroupRowProps {
  groupState: GroupState;
  isRowHovered: boolean | undefined;
  toggleGroupDown: boolean;
  handleGroupDropdownToggle: () => void;
  openDeleteModalGroup: () => void;
  segmentOrPg: string;
  isEditGroupMode: EditGroupMode;
  openShareModalGroup: () => void;
}

const CategoryLeaderboardGroupRow: React.FC<GroupRowProps> = ({
  groupState,
  isRowHovered,
  toggleGroupDown,
  handleGroupDropdownToggle,
  openDeleteModalGroup,
  segmentOrPg,
  isEditGroupMode,
  openShareModalGroup,
}) => {
  const { Menu, IconButton } = actions;
  const { Icon } = elements;
  const { ChevronUp, ChevronDown, AddGroup, Share, Delete } = IconButton.icons;

  const isDropdownDisabled =
    (groupState?.isGroupEmpty ? true : null) ?? (isEditGroupMode?.isEditMode ? true : null) ?? false;

  const dropdownIcon = toggleGroupDown && !isEditGroupMode.isEditMode ? <ChevronUp /> : <ChevronDown />;

  const moreMenu = isRowHovered ? (
    <div className={styles.TableViewboard__TableCell__MoreMenu}>
      <Menu isDisabled={isEditGroupMode.isEditMode}>
        <Menu.MoreButton />
        <Menu.List>
          {groupState.isPreferenceOwner ? (
            <>
              <Menu.Item onSelect={groupState?.enableIsEditGroupMode!}>
                <Icon>
                  <AddGroup />
                </Icon>
                {`Add to group`}
              </Menu.Item>
              <Menu.Item onSelect={openShareModalGroup} isDisabled={isShareGroupButtonDisable(groupState)}>
                <Icon>
                  <Share />
                </Icon>
                Share group
              </Menu.Item>
            </>
          ) : (
            <></>
          )}
          <Menu.Item onSelect={openDeleteModalGroup}>
            <Icon>
              <Delete />
            </Icon>
            Delete group
          </Menu.Item>
        </Menu.List>
      </Menu>
    </div>
  ) : (
    <div className={styles.TableViewboard__TableCell__MoreMenu_padding} />
  );

  return (
    <td
      key={segmentOrPg}
      className={classnames(styles.TableViewboard__TableCell, styles.TableViewboard__TableCell_Total)}
    >
      <div className={styles.TableViewboard__TableCell__grouping}>
        <IconButton testId="button-icon" onClick={handleGroupDropdownToggle} disabled={isDropdownDisabled}>
          {dropdownIcon}
        </IconButton>
        <p>{segmentOrPg}</p>
        {moreMenu}
      </div>
    </td>
  );
};

export default CategoryLeaderboardGroupRow;
